const ReactDataGrid = require('react-data-grid');
import React from 'react';
import ReactDOM from 'react-dom';
import ServiceHelper from '../remote/ServiceHelper';
import Command from '../remote/Command';
import StringUtil from '../utils/StringUtil';
import GOTUtil from '../utils/GOTUtil';
import QueryUtil from '../utils/QueryUtil';
import styles from './styles.css';
import Warning from '../utils/Warn';
import Fade from '../utils/Fade';



export default class GlobalUserSetForm extends React.Component {
	constructor(props, context) {
		super(props, context);
		// window.userSettingEntry = {
		//   autoEnterList: false, // 自动进入列表
		//   //clickEnterList:false,  //
		//   //flickerTime:800,   //
		//   isAutoSavePrompt: false, // 自动保存提示
		//   isDelPrompt: true,  //删除提示
		//   isEditMode: true,  
		//   isEditModeHelp: true,
		//   isRecSavePrompt: false,  //recordsave 提醒
		//   isReportBrowser: true,
		//   isShowBusyRemote: true,
		//   showOprInfo: false,
		//   downNewRec: false,    
		//   showLeftMenu: false,  //左边侧边栏
		//   showToolMenu: true   //工具栏
		// }
		this.userSettingEntry =Object.assign({remoteClass:"gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity"},window.userSettingEntry);
		// this.userSettingEntry.remoteClass = "gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity";
		// this.userSettingEntry = {
		// 	autoEnterList:false,
		// 	clickEnterList:true,
		// 	downNewRec:false,
		// 	flickerTime:1000,
		// 	isAutoSavePrompt:false,
		// 	isDebug:false,
		// 	isDelPrompt:true,
		// 	isEditMode:true,
		// 	isRecSavePrompt:false,
		// 	isReportBrowser:true,
		// 	isShowBusyRemote:true,
		// 	isStayWindowMem:true,
		// 	showLeftMenu:true,
		// 	showOprInfo:false,
		// 	showToolMenu:false,
		// 	useFixedForm:false,
		// 	useFixedMainMenu:true
		// }
		console.log(this.userSettingEntry);

		//判断是否是管理员
		this.userInfos = window.userInfos;
		console.log(this.userInfos);
		if (this.userInfos.userGroups.indexOf("admin") != -1 || this.userInfos.userGroups.indexOf("Admin") != -1) {
		  this.isAdmin = true;
		}
		else{
			this.isAdmin = false;
		}
		console.log(this.isAdmin);

    	this.state = {
			
		};
	}
	componentDidMount(){
		if(this.isAdmin == false){
			$("#tabli_5").css("display","none");
		}else{
			$("#tabli_5").css("display", "block");
		}

		$(".tab_container > div > label > input[type='checkbox']").prop("checked", false);

		var init = this.userSettingEntry;
		if(init.autoEnterList == true){
			$("#autoEnterListCheckBox").prop("checked",true);
		}
		if (init.clickEnterList == true) {
			$("#clickEnterListCheckBox").prop("checked", true);
		}
		if(init.pressEditList == true)
		{
			$("#clickPressEditCheckBox").prop("checked",true)
		}
		if (init.downNewRec == true) {
			$("#downNewRecCheckBox").prop("checked",true);
		}
		if (init.isAutoSavePrompt == true) {
			$("#isAutoSavePromptCheckBox").prop("checked", true);
		}
		if (init.isDebug == true) {
			$("#isDebugCheckBox").prop("checked", true);
		}
		if (init.isDelPrompt == true) {
			$("#isDelPromptCheckBox").prop("checked",true);
		}

		if(init.showBottomSum == true)
		{
			$("#isShowBottomSumCheckBox").prop("checked",true);
		}

		if (init.isEditMode == true) {
			$("#isEditModeCheckBox").prop("checked", true);
		}

		if (init.isRecSavePrompt == true) {
		  $("#isRecSavePromptCheckBox").prop("checked", true);
		}
		if (init.isReportBrowser == true) {
		  $("#isReportBrowserCheckBox").prop("checked", true);
		}
		if (init.isShowBusyRemote == true) {
		  $("#isShowBusyRemoteCheckBox").prop("checked", true);
		}
		if (init.isStayWindowMem == true) {
		//   $("#isStayWindowMemCheckBox").prop("checked", true);
		}
		if (init.showLeftMenu == true) {
		  $("#showLeftMenuCheckBox").prop("checked", true);
		}
		
		if(init.showLeftListMenu == true)
		{
			$("#showLeftListMenuCheckBox").prop("checked", true);
		}

		if(init.hideToolBar == true)
		{
			$("#hideToolBarCheckBox").prop("checked", true);
		}

		if(init.innerToolBar == true)
		{
			$("#innerToolBarCheckBox").prop("checked", true);
		}

		if (init.showOprInfo == true) {
		//   $("#showOprInfoCheckBox").prop("checked", true);
		}
		if (init.showToolMenu == true) {
		  $("#showToolMenuCheckBox").prop("checked", true);
		}
		if (init.useFixedForm == true) {
		//   $("#useFixedFormCheckBox").prop("checked", true);
		}
		if (init.useFixedMainMenu == true) {
		//   $("#useFixedMainMenuCheckBox").prop("checked", true);
		}
	}

	//关闭
	hideGlobalUserSetForm = () => {
		let $reactComponentContainer = $("#globalUserSetFormDiv");
		ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
		//$reactComponentContainer.remove();
		$("#globalUserSetFormDiv").empty().css("display", "none");
	}

	changeisShowBusyRemote =() =>{
		var tag = $("#isShowBusyRemoteCheckBox").prop("checked");
		// alert("isShowBusyRemote"+tag);
		window.userSettingEntry.isShowBusyRemote = tag;
		this.userSettingEntry.isShowBusyRemote = tag;
	}

	changeisRecSavePrompt =() =>{
		var tag = $("#isRecSavePromptCheckBox").prop("checked");
		window.userSettingEntry.isRecSavePrompt = tag;
		this.userSettingEntry.isRecSavePrompt = tag;
	}

	changeisAutoSavePrompt = () => {
	  var tag = $("#isAutoSavePromptCheckBox").prop("checked");
	  window.userSettingEntry.isAutoSavePrompt = tag;
	  this.userSettingEntry.isAutoSavePrompt = tag;
	}

	changeisDelPrompt = () => {
	  var tag = $("#isDelPromptCheckBox").prop("checked");
	  window.userSettingEntry.isDelPrompt = tag;
	  this.userSettingEntry.isDelPrompt = tag;
	}

	changeBottomSumShow = () => {
		var tag = $("#isShowBottomSumCheckBox").prop("checked");
		window.userSettingEntry.showBottomSum = tag;
		this.userSettingEntry.showBottomSum = tag;
	}

	changedownNewRec = () => {
	  var tag = $("#downNewRecCheckBox").prop("checked");
	  window.userSettingEntry.downNewRec = tag;
	  this.userSettingEntry.downNewRec = tag;
	}

	changeautoEnterList = () => {
	  var tag = $("#autoEnterListCheckBox").prop("checked");
	  window.userSettingEntry.autoEnterList = tag;
	  this.userSettingEntry.autoEnterList = tag;
	}

	changeclickEnterList = () =>{
		var tag = $("#clickEnterListCheckBox").prop("checked");
		window.userSettingEntry.clickEnterList = tag;
		this.userSettingEntry.clickEnterList = tag;
	}

	changePressEditList = () =>{
		var tag = $("#clickPressEditCheckBox").prop("checked");
		window.userSettingEntry.pressEditList = tag;
		this.userSettingEntry.pressEditList = tag;
	}

	changeshowToolMenu = () => {
		var tag = $("#showToolMenuCheckBox").prop("checked");
		window.userSettingEntry.showToolMenu = tag;
		this.userSettingEntry.showToolMenu = tag;
		/*if(tag)//如果启用工具栏菜单 则把左侧主菜单隐藏
		{
			this.userSettingEntry.showLeftMenu = false;
			window.userSettingEntry.showLeftMenu = false;
		}
		else//否则确保左侧主菜单要显示
		{
			this.userSettingEntry.showLeftMenu = true;
			window.userSettingEntry.showLeftMenu = true;
		}*/
		
	}
	
	changeshowLeftMenu = () => {
		var tag = $("#showLeftMenuCheckBox").prop("checked");
	 	window.userSettingEntry.showLeftMenu = tag;
		this.userSettingEntry.showLeftMenu = tag;
		if(tag == true)
		{
			var tag = $("#showLeftListMenuCheckBox").prop("checked",false);
	 		window.userSettingEntry.showLeftListMenu = false;
			this.userSettingEntry.showLeftListMenu = false;
		}
	}

	changeshowLeftListMenu = () => {
		var tag = $("#showLeftListMenuCheckBox").prop("checked");
	 	window.userSettingEntry.showLeftListMenu = tag;
		this.userSettingEntry.showLeftListMenu = tag;

		if(tag == true)
		{
			var tag = $("#showLeftMenuCheckBox").prop("checked",false);
	 		window.userSettingEntry.showLeftMenu = false;
			this.userSettingEntry.showLeftMenu = false;
		}
	}
	
	changeHideToolBar = () => {
		var tag = $("#hideToolBarCheckBox").prop("checked");
	 	window.userSettingEntry.hideToolBar = tag;
		this.userSettingEntry.hideToolBar = tag;
	}

	changeInnerToolBar = () => {
		var tag = $("#innerToolBarCheckBox").prop("checked");
	 	window.userSettingEntry.innerToolBar = tag;
		this.userSettingEntry.innerToolBar = tag;
		if(tag)//如果把工具栏放到画面内 则要隐藏画面外的工具栏
		{
			window.userSettingEntry.hideToolBar = true;
			this.userSettingEntry.hideToolBar = true;
		}
		else//否则要保证画面外的工具栏是显示的
		{
			window.userSettingEntry.hideToolBar = false;
			this.userSettingEntry.hideToolBar = false;
		}
		
	}

	changeisReportBrowser = () => {
		var tag = $("#isReportBrowserCheckBox").prop("checked");
	 	window.userSettingEntry.isReportBrowser = tag;
		this.userSettingEntry.isReportBrowser = tag;
	}

	changeisDebug = () => {
		var tag = $("#isReportBrowserCheckBox").prop("checked");
	 	window.userSettingEntry.isDebug = tag;
		this.userSettingEntry.isDebug = tag;
	}
	changeisEditMode = () => {
		var tag = $("#isEditModeCheckBox").prop("checked");
	 	window.userSettingEntry.isEditMode = tag;
		this.userSettingEntry.isEditMode = tag;
	}
	

	btnRestore_clickHandler = () =>{

		// 自动进入列表autoEnterList false
		window.userSettingEntry.autoEnterList = false;
		this.userSettingEntry.autoEnterList = false;
		// $("#autoEnterListCheckBox").prop("checked", false);
		
		// clickEnterList true
		window.userSettingEntry.clickEnterList = true;
		this.userSettingEntry.clickEnterList = true;

		window.userSettingEntry.pressEditList = false;
		this.userSettingEntry.pressEditList = false;
		
		// flickerTime 800
		window.userSettingEntry.flickerTime = 800;
		this.userSettingEntry.flickerTime = 800;
		
		
		// isAutoSavePrompt false
		window.userSettingEntry.isAutoSavePrompt = false;
		this.userSettingEntry.isAutoSavePrompt = false;
		// $("#isAutoSavePromptCheckBox").prop("checked",false);
		
		// isDebug false
		window.userSettingEntry.isDebug = false;
		this.userSettingEntry.isDebug = false;
		// $("#isDebugCheckBox").prop("checked", false);
		
		//showBottomSum false
		window.userSettingEntry.showBottomSum = false;
		this.userSettingEntry.showBottomSum = false;

		// isDelPrompt true
		window.userSettingEntry.isDelPrompt = true;
		this.userSettingEntry.isDelPrompt = true;
		// $("#isDelPromptCheckBox").prop("checked",true);
		
		// isEditMode true
		window.userSettingEntry.isEditMode = true;
		this.userSettingEntry.isEditMode = true;
		// $("#isEditModeCheckBox").prop("checked",true);
		
		// isRecSavePrompt false
		window.userSettingEntry.isRecSavePrompt = false;
		this.userSettingEntry.isRecSavePrompt = false;
		// $("#isRecSavePromptCheckBox").prop("checked",false);
		
		// isReportBrowser true
		window.userSettingEntry.isReportBrowser = true;
		this.userSettingEntry.isReportBrowser = true;
		// $("#isReportBrowserCheckBox").prop("checked",true);
		
		// isShowBusyRemote true
		window.userSettingEntry.isShowBusyRemote = true;
		this.userSettingEntry.isShowBusyRemote = true;
		// $("#isShowBusyRemoteCheckBox").prop("checked",true);
		
		// isStayWindowMem true
		window.userSettingEntry.isStayWindowMem = true;
		this.userSettingEntry.isStayWindowMem = true;
		
		// useFixedMainMenu true
		window.userSettingEntry.useFixedMainMenu = true;
		this.userSettingEntry.useFixedMainMenu = true;
		
		
		// useFixedForm false
		window.userSettingEntry.useFixedForm = false;
		this.userSettingEntry.useFixedForm = false;
		
		
		// ugse.downNewRec = false;
		window.userSettingEntry.downNewRec = false;
		this.userSettingEntry.downNewRec = false;
		// $("#downNewRecCheckBox").prop("checked",false);
		
		// ugse.showOprInfo = false;
		window.userSettingEntry.showOprInfo = false;
		this.userSettingEntry.showOprInfo = false;
		
		// //showOprInfo.selected = false;
		window.userSettingEntry.showOprInfo = false;
		this.userSettingEntry.showOprInfo = false;
		
		// ugse.showLeftMenu = true;
		window.userSettingEntry.showLeftMenu = true;
		this.userSettingEntry.showLeftMenu = true;
		// $("#showLeftMenuCheckBox").prop("checked",true);
		
		
		// ugse.showToolMenu = false;
		window.userSettingEntry.showToolMenu = false;
		this.userSettingEntry.showToolMenu = false;
		// $("#showToolMenuCheckBox").prop("checked",false);

		window.userSettingEntry.hideToolBar = false;
		this.userSettingEntry.hideToolBar = false;

		window.userSettingEntry.innerToolBar = false;
		this.userSettingEntry.innerToolBar = false;
		
		this.componentDidMount();
		
	}

	btnsave_clickHandler = () =>{
		var ugse =  this.userSettingEntry;
		var userId = this.userInfos.userId;
		
		for (var k in ugse) {
			ugse[k] = ugse[k].toString();

		}
		if(typeof(window.userSettingEntryOrig.menuCustomObject) != "string")
		{
			ugse.menuCustomObject = JSON.stringify(window.userSettingEntryOrig.menuCustomObject);
		}
		else
		{
			ugse.menuCustomObject = window.userSettingEntryOrig.menuCustomObject;
		}
		
		console.log(ugse);
		// var saveFaultHandler = function(data)
		// {
		// 	alert("保存失败","提示");	
		// }
		var saveResultHandler = function(data)
		{
			window.userSettingEntryOrig = ugse;
			console.log(data);
			if(Boolean(data.result))
			{
				if(Boolean(data.result))
				{
					var options={
						state:'success',
						text: "已成功保存您的偏好设置"
					}
					Fade.show(options);
				}
				else
				{
					var options = {
					  state: 'error',
					  text: "保存失败"
					}
					Fade.show(options);
					// alert("保存失败","提示");	
				}
			}
		}
		
		var command = Command.createService( "gongqi.erp.gotmodel.services.UserSettingService", "saveUserProperties", "boolean");
		
		command.appendArg(userId); //ClientSession.getClientSessionInstance().userId
		command.appendArg(ugse,"gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity");
		
		var remoteArg = {
			command: command,
			resultFunction: saveResultHandler,
			sync: false
		}
		ServiceHelper.addTokenWithCommand(remoteArg);
	}

	loadGlobalHandler = () =>{
		var command= Command.createService( "gongqi.erp.gotmodel.services.UserSettingService", "loadUserProperties", "UserGlobalSetEntity");
		command.appendArg("_default");
		var self = this;
		var Fun = function(data){
			var ugse = data.result;
			console.log(data);
			// 自动进入列表autoEnterList false
			window.userSettingEntry.autoEnterList = ugse.autoEnterList;
			self.userSettingEntry.autoEnterList = ugse.autoEnterList;
			// $("#autoEnterListCheckBox").prop("checked", false);
			
			// clickEnterList true
			window.userSettingEntry.clickEnterList = ugse.clickEnterList;
			self.userSettingEntry.clickEnterList = ugse.clickEnterList;
			
			// flickerTime 800
			window.userSettingEntry.flickerTime = ugse.flickerTime;
			self.userSettingEntry.flickerTime = ugse.flickerTime;
			
			
			window.userSettingEntry.pressEditList = ugse.pressEditList;
			self.userSettingEntry.pressEditList = ugse.pressEditList;

			// isAutoSavePrompt false
			window.userSettingEntry.isAutoSavePrompt = ugse.isAutoSavePrompt;
			self.userSettingEntry.isAutoSavePrompt = ugse.isAutoSavePrompt;
			// $("#isAutoSavePromptCheckBox").prop("checked",false);
			
			// isDebug false
			window.userSettingEntry.isDebug = ugse.isDebug;
			self.userSettingEntry.isDebug = ugse.isDebug;
			// $("#isDebugCheckBox").prop("checked", false);
			
			// isDelPrompt true
			window.userSettingEntry.isDelPrompt = ugse.isDelPrompt;
			self.userSettingEntry.isDelPrompt = ugse.isDelPrompt;
			// $("#isDelPromptCheckBox").prop("checked",true);
			
			window.userSettingEntry.showBottomSum = ugse.showBottomSum;
			self.userSettingEntry.showBottomSum = ugse.showBottomSum;

			// isEditMode true
			window.userSettingEntry.isEditMode = ugse.isEditMode;
			self.userSettingEntry.isEditMode = ugse.isEditMode;
			// $("#isEditModeCheckBox").prop("checked",true);
			
			// isRecSavePrompt false
			window.userSettingEntry.isRecSavePrompt = ugse.isRecSavePrompt;
			self.userSettingEntry.isRecSavePrompt = ugse.isRecSavePrompt;
			// $("#isRecSavePromptCheckBox").prop("checked",false);
			
			// isReportBrowser true
			window.userSettingEntry.isReportBrowser = ugse.isReportBrowser;
			self.userSettingEntry.isReportBrowser = ugse.isReportBrowser;
			// $("#isReportBrowserCheckBox").prop("checked",true);
			
			// isShowBusyRemote true
			window.userSettingEntry.isShowBusyRemote = ugse.isShowBusyRemote;
			self.userSettingEntry.isShowBusyRemote = ugse.isShowBusyRemote;
			// $("#isShowBusyRemoteCheckBox").prop("checked",true);
			
			// isStayWindowMem true
			window.userSettingEntry.isStayWindowMem = ugse.isStayWindowMem;
			self.userSettingEntry.isStayWindowMem = ugse.isStayWindowMem;
			
			// useFixedMainMenu true
			window.userSettingEntry.useFixedMainMenu = ugse.useFixedMainMenu;
			self.userSettingEntry.useFixedMainMenu = ugse.useFixedMainMenu;
			
			
			// useFixedForm false
			window.userSettingEntry.useFixedForm = ugse.useFixedForm;
			self.userSettingEntry.useFixedForm = ugse.useFixedForm;
			
			
			// ugse.downNewRec = false;
			window.userSettingEntry.downNewRec = ugse.downNewRec;
			self.userSettingEntry.downNewRec = ugse.downNewRec;
			// $("#downNewRecCheckBox").prop("checked",false);
			
			// ugse.showOprInfo = false;
			window.userSettingEntry.showOprInfo = ugse.showOprInfo;
			self.userSettingEntry.showOprInfo = ugse.showOprInfo;
			
			
			// ugse.showLeftMenu = true;
			window.userSettingEntry.showLeftMenu = ugse.showLeftMenu;
			self.userSettingEntry.showLeftMenu = ugse.showLeftMenu;
			// $("#showLeftMenuCheckBox").prop("checked",true);
			
			
			// ugse.showToolMenu = false;
			window.userSettingEntry.showToolMenu = ugse.showToolMenu;
			self.userSettingEntry.showToolMenu = ugse.showToolMenu;
			// $("#showToolMenuCheckBox").prop("checked",false);

			window.userSettingEntry.hideToolBar = ugse.hideToolBar;
			self.userSettingEntry.hideToolBar = ugse.hideToolBar;

			window.userSettingEntry.innerToolBar = ugse.innerToolBar;
			self.userSettingEntry.innerToolBar = ugse.innerToolBar;
			
			self.componentDidMount();
		}
		// var loadFaultHandler = function(data){

		// }
		// var Fun = function (data){
		// 	console.log(data);
		// }
		var remoteArg = {
			command: command,
			// loadResultHandler, loadFaultHandler,
			resultFunction: Fun,
			sync: false
		}
		ServiceHelper.addTokenWithCommand(remoteArg);
	}

	saveGlobalHandler = () =>{
		var ugse = this.userSettingEntry;
		var command = Command.createService( "gongqi.erp.gotmodel.services.UserSettingService", "saveUserProperties", "boolean");
		
		command.appendArg("_default");
		command.appendArg(ugse,"gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity");
		var saveGlobalResultHandler = function(data){
			if (Boolean(data.result)) {
			  var options = {
			    state: 'success',
			    text: "已成功保存您的偏好设置"
			  }
			  Fade.show(options);
			} else {
			//   alert("保存失败", "提示");
			  var options = {
			    state: 'error',
			    text: "保存失败"
			  }
			  Fade.show(options);
			}
		}		
		var remoteArg ={
			command: command,
			// saveGlobalResultHandler, saveGlobalFaultHandler,
			resultFunction: saveGlobalResultHandler,
			sync: false
		}
		ServiceHelper.addTokenWithCommand(remoteArg);
	}

	render(){
		
		return(

			<div  style={{alignSelf:"center",borderRadius:"2px",backgroundColor:'white',width:'600px',height:'410px',display:'flex',flexDirection:'column',border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)'}}>
		      <div className="modal-header" style={{background:"#ffffff",padding:"10px",position:"relative",paddingTop:"15px",paddingBottom:"15px",background:"#F8F8F8"}}>
				<div className="modal-close" onClick={this.hideGlobalUserSetForm.bind(this)}></div>
		        <h5 className="modal-title">参数设置</h5>
		      </div>
              
			  <div style={{display:'flex',flexDirection:'column',flexGrow:100,padding:'5px'}}>
		       	<div style={{display:'flex',flexDirection:'row',flexGrow:100,boxShadow:'none',borderRadius:'3px'}}>
                    <div style={{display:'flex',flexDirection:'column',width:'900px'}}>
		       			<div className="nav-tabs-custom" style={{'marginBottom': '0',display:'flex',flexDirection:'column',height:'100%',boxShadow:'none'}}>
          					<ul className="nav nav-tabs" style={{paddingTop:'8px'}}>
            					<li id="tabli_1" className="active"><a style={{paddingBottom:'10px'}} className="gongqi_tabpage" href="#globalUserSetForm_tab_1" data-toggle="tab" aria-expanded="false">交互</a></li>
            					<li id="tabli_2" ><a style={{paddingBottom:'10px'}} className="gongqi_tabpage" id="globalUserSetForm_tab_btn_2" href="#globalUserSetForm_tab_2" data-toggle="tab" aria-expanded="false">画面</a></li>
            					<li id="tabli_3" ><a style={{paddingBottom:'10px'}} className="gongqi_tabpage" id="globalUserSetForm_tab_btn_3" href="#globalUserSetForm_tab_3" data-toggle="tab" aria-expanded="false">报表</a></li>
								<li id="tabli_4" ><a style={{paddingBottom:'10px'}} className="gongqi_tabpage" id="globalUserSetForm_tab_btn_4" href="#globalUserSetForm_tab_4" data-toggle="tab" aria-expanded="false">调试</a></li>
								<li id="tabli_5" ><a style={{paddingBottom:'10px'}} className="gongqi_tabpage" id="globalUserSetForm_tab_btn_5" href="#globalUserSetForm_tab_5" data-toggle="tab" aria-expanded="false">全局</a></li>
          					</ul>
                            <div className="tab-content" style={{'padding':'0px',flexGrow:100,width:'100%',height:'100%'}}>
            					<div className="active tab-pane" id="globalUserSetForm_tab_1" style={{width:'100%',height:'100%',padding:'1px',flexDirection:'row',paddingTop:'10px'}}>
            						<div className="tab_container" style={{height:'100%'}}>
                                    {/* 										
										<div class="checkbox">
											<label>
												<input type="checkbox"/> Check me out
											</label>
										</div> */}
										<div draggable="true" style={{paddingLeft:'15px'}}>
											<label><input style={{marginRight:'10px'}} type="checkbox" id="isShowBusyRemoteCheckBox" name="" value="on" onClick={this.changeisShowBusyRemote} />远程交互时鼠标忙&emsp;</label>
										</div>
										{/*<div draggable="true" style={{paddingLeft:'15px'}} id="">
											<label><input style={{marginRight:'10px'}} type="checkbox" id="isAutoSavePromptCheckBox" name="" value="on" onClick={this.changeisAutoSavePrompt}/>自动保存当前记录是否提醒&emsp;</label>
										</div>
										<div draggable="true" style={{paddingLeft:'15px'}} id="">
											<label><input style={{marginRight:'10px'}} type="checkbox" id="isRecSavePromptCheckBox" name="" value="on" onClick={this.changeisRecSavePrompt}/>RecordSave是否提醒&emsp;</label>
										</div>*/}
										<div draggable="true" style={{paddingLeft:'15px'}}>
											<label><input style={{marginRight:'10px'}} type="checkbox" id="isDelPromptCheckBox" name="" value="on" onClick={this.changeisDelPrompt}/>记录删除时是否提醒&emsp;</label>
										</div>
										<div draggable="true" style={{display:'none',paddingLeft:'15px'}}>
											<label><input style={{marginRight:'10px'}} type="checkbox" id="isShowBottomSumCheckBox" name="" value="off" onClick={this.changeBottomSumShow}/>是否显示底部合计栏&emsp;</label>
										</div>
										<div draggable="true" style={{display:'none',paddingLeft:'15px'}}>
											<label><input style={{marginRight:'10px'}} type="checkbox" id="downNewRecCheckBox" name="" value="on" onClick={this.changedownNewRec}/>列表中下移记录时新增记录&emsp;</label>
										</div>

										<div draggable="true" style={{paddingLeft:'15px'}}>
											<label><input style={{marginRight:'10px'}} type="checkbox" id="isEditModeCheckBox" name="" value="on" onClick={this.changeisEditMode} />登陆默认编辑模式&emsp;</label>
										</div>

										
									</div>
								</div>
            					<div className="tab-pane"  id="globalUserSetForm_tab_2" style={{width:'100%',height:'100%',paddingTop:'10px'}}>
									<div className="tab_container" style={{height:'100%'}}>
										<div draggable="true" id="" style={{paddingLeft:'15px'}}>
											<label><input style={{marginRight:'10px'}} type="checkbox" id="autoEnterListCheckBox" name="" value="on" onClick={this.changeautoEnterList} />列表自动进入&emsp;</label>
										</div>
										<div draggable="true" style={{display:'none',paddingLeft:'15px'}} id="">
											<label><input style={{marginRight:'10px'}} type="checkbox" id="clickEnterListCheckBox" name="" value="on" onClick={this.changeclickEnterList}/>列表单击可编辑&emsp;</label>
										</div>
										<div draggable="true" style={{paddingLeft:'15px'}}>
											<label><input style={{marginRight:'10px'}} type="checkbox" id="clickPressEditCheckBox" name="" value="on" onClick={this.changePressEditList}/>列表输入时自动编辑&emsp;</label>
										</div>
										<div draggable="true" style={{paddingLeft:'15px'}}>
											<label><input style={{marginRight:'10px'}} type="checkbox" id="showLeftMenuCheckBox" name="" value="on" onClick={this.changeshowLeftMenu}/>使用左侧树形菜单&emsp;</label>
										</div>
										<div draggable="true" style={{paddingLeft:'15px'}}>
											<label><input style={{marginRight:'10px'}} type="checkbox" id="showLeftListMenuCheckBox" name="" value="off" onClick={this.changeshowLeftListMenu}/>使用左侧列表菜单&emsp;</label>
										</div>
										<div draggable="true" id="" style={{paddingLeft:'15px'}}>
											<label><input style={{marginRight:'10px'}} type="checkbox" id="showToolMenuCheckBox" name="" value="off" onClick={this.changeshowToolMenu}/>使用工具栏菜单&emsp;</label>
										</div>
										
										{/*<div draggable="true">
											<label>显示左侧菜单&emsp;<input type="checkbox" id="showLeftMenuCheckBox" name="" value="on" onClick={this.changeshowLeftMenu}/></label>
										</div>
										<div draggable="true" id="">
											<label>隐藏工具栏&emsp;<input type="checkbox" id="hideToolBarCheckBox" name="" value="on" onClick={this.changeHideToolBar}/></label>
										</div>*/}
										<div draggable="true" style={{paddingLeft:'15px'}}>
											<label><input style={{marginRight:'10px'}} type="checkbox" id="innerToolBarCheckBox" name="" value="off" onClick={this.changeInnerToolBar}/>把工具栏放在画面内&emsp;</label>
										</div>
									</div>
            					</div>
								<div className="tab-pane"  id="globalUserSetForm_tab_3" style={{width:'100%',height:'100%',paddingTop:'10px'}}>
									<div className="tab_container" style={{height:'100%'}}>
										<div draggable="true" style={{paddingLeft:'15px'}}>
											<label><input style={{marginRight:'10px'}} type="checkbox" name="" id="isReportBrowserCheckBox" value="on" onClick={this.changeisReportBrowser} />使用浏览器预览报表&emsp;</label>
										</div>
									</div>
            					</div>
								<div className="tab-pane"  id="globalUserSetForm_tab_4" style={{width:'100%',height:'100%',paddingTop:'10px'}}>
									<div className="tab_container" style={{height:'100%'}}>
										<div draggable="true" style={{paddingLeft:'15px'}}>
											<label><input style={{marginRight:'10px'}} type="checkbox" name="" id="isDebugCheckBox" value="on" onClick={this.changeisDebug} />调试模式&emsp;</label>
										</div>
									</div>
            					</div>
								<div className="tab-pane"  id="globalUserSetForm_tab_5" style={{width:'100%',height:'100%',paddingTop:'10px'}}>
									<div className="tab_container" style={{height:'100%'}}>
										<div style={{width:'100%',textAlign:'center',paddingTop:'50px'}}>
											<button type="button" className="btn btn-info" onClick={this.loadGlobalHandler}>加载全局默认设置</button>
										</div>
										<div style={{width:'100%',textAlign:'center'}}>
											<button type="button" className="btn btn-info" onClick={this.saveGlobalHandler}>保存为全局默认设置</button>
										</div>
									</div>
            					</div>
          					</div>
        				</div>
		       		</div>
		       	</div>
				   
				<div style={{display:'flex',flexDirection:'horizontal',flexGrow:0,paddingTop:'10px',paddingBottom:'10px'}}>
					<div style={{flexGrow:100}}></div>
					<button type="button" className="btn btn-info" style={{height:'25px',marginRight:'5px',marginTop:'5px'}}  onClick={this.btnRestore_clickHandler} >恢复默认</button>
					<button type="button" className="btn btn-info" style={{height:'25px',marginTop:'5px'}} onClick={this.btnsave_clickHandler}>保存</button>
				</div>
		      </div>


		    </div>

		)
	}

}


// WEBPACK FOOTER //
// ./src/globalUserSet/GlobalUserSetForm.js